<template>
    <div>
        <card-header title="Conference Details" icon="fa-presentation"/>

        <card-toolbar>
            <button @click="$openCard('rmc-edit-conference', {confId: conference.id}, card)"><i class="far fa-pencil"></i>Edit Details</button>
            <button @click="view"><i class="far fa-external-link-alt"></i>View</button>
        </card-toolbar>

        <card-body>
            <card-list>
                <rmc-conf-tile :card="card" :conf="conference" :summary="false"/>
                <subheader-list-item title="Overview" icon="fa-align-left"/>
                <container-list-item>
                    <data-row title="Conference Code">
                        <b-tag type="is-primary"><i class="far fa-tag ml-1 mr-1"></i> {{ conference.code }}</b-tag>
                    </data-row>
                    <data-row title="Dates">{{ confDates }}</data-row>
                    <data-row title="Registrations">{{ conference.registrations.length }} ({{ conference.pending }} pending)</data-row>
                    <data-row title="Revenue">{{ conference.revenue | currency }} ({{ conference.pendingRevenue | currency }} pending)</data-row>
                </container-list-item>

                <subheader-list-item title="Registrations" icon="fa-users"/>
                <search-list-item/>
                <separator-list-item/>

                <navigation-list-item
                        @click="$openCard('rmc-registrations', {type: 'all', confId: conference.id}, card)"
                        title="All Registrations" icon="fa-users"
                        :badge="conference.registrations.length"
                        :active="(child && child.definition.component === 'rmc-registrations' && conference.id === parseInt(child.props.confId) && 'all' === child.props.type)"
                />

                <navigation-list-item
                        @click="$openCard('rmc-registrations', {type: 'pending', confId: conference.id}, card)"
                        title="Pending" icon="fa-exclamation-circle"
                        :badge="conference.pending"
                        :active="(child && child.definition.component === 'rmc-registrations' && conference.id === parseInt(child.props.confId) && 'pending' === child.props.type)"
                />

                <navigation-list-item
                    @click="$openCard('rmc-registrations', {type: 'complete', confId: conference.id}, card)"
                    title="Complete"
                    icon="fa-check"
                    :active="(child && child.definition.component === 'rmc-registrations' && conference.id === parseInt(child.props.confId) && 'complete' === child.props.type)"
                />

                <navigation-list-item
                    @click="$openCard('rmc-registrations', {type: 'cc', confId: conference.id}, card)"
                    title="Paid by Credit Card"
                    icon="fa-credit-card"
                    :active="(child && child.definition.component === 'rmc-registrations' && conference.id === parseInt(child.props.confId) && 'cc' === child.props.type)"
                />

                <navigation-list-item
                    @click="$openCard('rmc-registrations', {type: 'po', confId: conference.id}, card)"
                    title="Paid by Purchase Order (P.O.)"
                    icon="fa-money-check-edit-alt"
                    :active="(child && child.definition.component === 'rmc-registrations' && conference.id === parseInt(child.props.confId) && 'po' === child.props.type)"
                />

                <navigation-list-item
                    @click="$openCard('rmc-registrations', {type: 'free', confId: conference.id}, card)"
                    title="Free Registrations"
                    icon="fa-hand-holding-usd"
                    :active="(child && child.definition.component === 'rmc-registrations' && conference.id === parseInt(child.props.confId) && 'free' === child.props.type)"
                />

                <subheader-list-item title="Setup" icon="fa-cogs"/>

                <navigation-list-item
                    title="Sessions"
                    icon="fa-users-class"
                    @click="$openCard('rmc-sessions', {type: 'free', confId: conference.id}, card)"
                    :active="(child && child.definition.component === 'rmc-sessions' && conference.id === parseInt(child.props.confId))"
                />

                <navigation-list-item
                    title="Registration Fees"
                    icon="fa-usd-square"
                    @click="$openCard('rmc-fees', {type: 'free', confId: conference.id}, card)"
                    :active="(child && child.definition.component === 'rmc-fees' && conference.id === parseInt(child.props.confId))"
                />

                <navigation-list-item
                    title="Registration Questions"
                    icon="fa-question-circle"
                    @click="$openCard('rmc-questions', {type: 'free', confId: conference.id}, card)"
                    :active="(child && child.definition.component === 'rmc-questions' && conference.id === parseInt(child.props.confId))"
                />

                <navigation-list-item title="Add-ons" icon="fa-layer-plus"/>

                <navigation-list-item
                    title="Discounts"
                    icon="fa-badge-dollar"
                    @click="$openCard('rmc-discounts', {type: 'free', confId: conference.id}, card)"
                    :active="(child && child.definition.component === 'rmc-discounts' && conference.id === parseInt(child.props.confId))"
                />

                <navigation-list-item
                    title="Surveys"
                    icon="fa-poll-people"
                    @click="$openCard('rmc-surveys', {confId: conference.id}, card)"
                    :active="(child && child.definition.component === 'rmc-surveys' && conference.id === parseInt(child.props.confId))"
                />

                <navigation-list-item
                    title="Certificates"
                    icon="fa-certificate"
                    @click="$openCard('rmc-certificates', {confId: conference.id}, card)"
                    :active="(child && child.definition.component === 'rmc-surveys' && conference.id === parseInt(child.props.confId))"
                />
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import SearchListItem from "@/TIER/components/SearchListItem";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import DataRow from "@/TIER/components/DataRow";

    import RmcConfTile from "@/components/rmc/RmcConfTile";

    import {client as http} from "@/http_client";
    import moment from "moment";

    export default {
        props: ['card', 'child', 'props'],
        components: {ContainerListItem, SeparatorListItem, RmcConfTile, DataRow, CardHeader, CardToolbar, CardBody, SearchListItem, NavigationListItem, SubheaderListItem, CardList},
        data() {
            return {
                conference: {
                    registrations: []
                }
            };
        },
        methods: {
            loadConference: function(force) {
                this.$emit('loading', true);
                http.get('rmc/conferences/' + this.props.confId, {force}).then(response => {
                    this.conference = response.data;
                    this.$emit('title', response.data.title);
                    this.$emit('loading', false);
                });
            },
            view: function() {
                window.open('https://www.registermyconference.com/#/register/' + this.conference.code)
            },
            reload: function() {
                this.loadConference(true);
            }
        },
        computed: {
            confDates: function() {
                let s = moment(this.conference.start_at);
                let e = moment(this.conference.end_at);
                if (s.isSame(e, 'day')) {
                    return s.format('MMMM D, YYYY');
                } else if (s.isSame(e, 'month')) {
                    return s.format('MMMM D - ') + e.format('D, YYYY');
                } else if (s.isSame(e, 'year')) {
                    return s.format('MMM D - ') + e.format('MMM D, YYYY');
                } else {
                    return s.format('MMM D, YYYY - ') + e.format('MMM D, YYYY');
                }
            }
        },
        watch: {
            'props.confId': function() {
                this.loadConference();
            }
        },
        mounted: function() {
            this.loadConference();
        }
    };
</script>

